import { useQuestionizerStore } from "../types/state";
import { Button } from "./button.tsx";
import Errors from "./errors";
import { useState } from "react";

export default function StepButtons(){
  const step = useQuestionizerStore((state) => state.step);
  const stepsCount = useQuestionizerStore((state) => state.stepsCount());
  const incrementStep = useQuestionizerStore((state) => state.incrementStep);
  const decrementStep = useQuestionizerStore((state) => state.decrementStep);
  const isCurrentStepValid = useQuestionizerStore((state) => state.isCurrentStepValid());
  const getCurrentStepErrors = useQuestionizerStore((state) => state.getCurrentStepErrors());
  const currentErrors = getCurrentStepErrors.filter(e => e.length > 0);
  const isInputTypeExistInPage = useQuestionizerStore((state) => state.isInputTypeExistInPage);
  const formWasMailed = useQuestionizerStore((state) => state.form_was_mailed);
  const config = useQuestionizerStore((state) => state.config);
  const currentSections = config?.layout[step].sections;
  const nextSections = config?.layout[step+1]?.sections;
  const lastSections = config?.layout[stepsCount-1]?.sections;
  const use_doi = config?.use_doi ?? false;
  const doi_confirm = useQuestionizerStore((state) => state.doi_confirm);
  const doi_wait_confirm = useQuestionizerStore((state) => state.doi_wait_confirm);
  const lead_sended = useQuestionizerStore((state) => state.lead_sended);
  const active_group = useQuestionizerStore((state) => state.active_group);

 const go_next = () => {
          document.querySelector(".top_section")?.focus();
          incrementStep();
        };
        
  var showButtonKontakt = false;
  if(nextSections && (nextSections == lastSections) && isInputTypeExistInPage(lastSections ?? [],"form") ){
	showButtonKontakt = true;
  }

  return <div inert={active_group ? true : false}>	  
	  <div className='step_buttons'>
		{ step > 0 ? <Button label="Zurück"
        icon_left_class="icon-inline--left icon-left--white"
        className="step_buttons__back"
        onClick={ decrementStep }
         onKeyUp={()=>{
          if ((event.code != " ")  && (event.code != "Enter")) { return } 
          decrementStep();
        }}
        />
    : <div></div>}
		<Errors></Errors>
		
		{ (step < (stepsCount-1) && !showButtonKontakt) ? 
    <Button 
      className="step_buttons__next"
      label="Weiter"
      aria_label={!isCurrentStepValid ? "Weiter deaktiviert. "+ currentErrors.join(", ") : "Weiter"}
      icon_right_class="icon-right--white"
      disabled={!isCurrentStepValid}
      onClick={incrementStep}/ > : 
    <div></div>}		
			
		{ (!use_doi || (doi_confirm && currentSections)) && isInputTypeExistInPage(currentSections,"result") && <PrintButton /> }
		{ currentSections && (currentSections == lastSections) && isInputTypeExistInPage(currentSections,"form")  && !formWasMailed &&  <SendEmailButton /> }
		{ currentSections && isInputTypeExistInPage(currentSections,"form") && use_doi && !doi_confirm && doi_wait_confirm && <DoiButton /> }
		
	  </div>
	  <div className='pt-4'/>
	  <div className='pt-4'>
	  		{ showButtonKontakt && 
        <Button 
          label={config?.text_btn_contact}
          icon_left_class="step_buttons__icon  pl-4"
          className="btn-full"
          onClick={go_next}
        />}
	  </div>
   </div>
}

function PrintButton(){
  const include_in_print = useQuestionizerStore((state) => state.include_in_print);
  const openPrintView = useQuestionizerStore((state) => state.openPrintView);

  const selected_for_print = Object.keys(include_in_print).filter(key => include_in_print[key]).length;
  let print_list_not_empty = selected_for_print > 0;

  return <Button label={"Auswahl Anzeigen / Drucken (" + selected_for_print + ")"}
                 aria_label={!print_list_not_empty ? "Auswahl Anzeigen / Drucken deaktiviert da die Auswahl leer ist" : ("Auswahl Anzeigen / Drucken ("  + selected_for_print + " Förderprogramme ausgewählt)")}
                 disabled={!print_list_not_empty}
                 icon_left_class="btn__icon_print"
                 className="btn--print step_buttons__next"
                 onClick={ () => openPrintView(undefined) }
          />
  }
  
function SendEmailButton(){
  const sendMail = useQuestionizerStore((state) => state.sendMail);
  return <div className={"step_buttons__button btn--print step_buttons__next btn"} 
              onClick={ (_) => sendMail() }>
                <span>Senden</span>
            </div>;
}

function DoiButton() {
  const sendDoiMail = useQuestionizerStore((state) => state.sendDoiMail);
  const setDoiWaitConfirm = useQuestionizerStore((state) => state.setDoiWaitConfirm);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSend = async () => {
    setLoading(true);
    setSuccess(false);
    try {
      await sendDoiMail();
      setSuccess(true);
    } catch (err) {
      alert("Fehler beim Senden der E-Mail.");
    }
    setLoading(false);
  };

  return (
    <div
      id="doi-request"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    >
      <div className="bg-white p-6 rounded-2xl max-w-lg w-full text-center shadow-xl">
        <h2 className="text-lg font-semibold">Bestätigungs-E-Mail wurde gesendet.</h2>
        <div className="mb-6">
          Bitte klicken Sie auf den <b>Link in der E-Mail</b>, um fortzufahren. Falls Sie keine E-Mail erhalten haben, 
		  können Sie den Button unten nutzen, um die E-Mail erneut zu senden.    
          {success && <div className="text-green-600 mt-2">E-Mail erfolgreich gesendet.</div>}
        </div>
        <button
          type="button"
          className="step_buttons__button btn--print step_buttons__next btn mx-auto"
          onClick={handleSend}
          aria-busy={loading}
          disabled={loading}
        >
          <span>{loading ? "Wird gesendet..." : "E-Mail nochmal senden"}</span>
        </button>
		<a className="doi-cancel" onClick={() => setDoiWaitConfirm(false)}>Abbrechen</a>
      </div>
    </div>
  );
}